import React, { useEffect } from "react";
import CustomButton from "../../../../components/Button/CustomButton";
import MainHeader from "../../../../components/Header/MainHeader";
import styles from "./Failed.module.scss";
import moment from "moment";
import { useNavigate } from "react-router-dom";

export default function Failed({ data }) {
  const navigate = useNavigate();

  useEffect(() => {
    const time = setTimeout(() => {
      navigate("/dashboard");
    }, 5000);

    return () => clearTimeout(time);
  }, []);

  return (
    <div className="wrapper">
      <div className="vertical-column-layout">
        <div className="vertical-column-top">
          <MainHeader title="Transaction Details" />

          <div className={styles.statucBlock}>
            <img src="/images/fail.png" alt="" />
            <p>Payment Failed</p>
            <h3>₹{data.amount_paid / 100}</h3>
          </div>
          <div className={styles.paymentInfo}>
            <div className={styles.infoBlock}>
              <div>Transaction ID:</div>
              <div>{data.id.split("_")[1]}</div>
            </div>

            <div className={styles.infoBlock}>
              <div>Payment Date:</div>
              <div>{moment.unix(data.created_at).format("DD MMM YYYY")}</div>
            </div>
          </div>
        </div>

        <div className="vertical-column-bottom">
          <CustomButton text="Continue" onClick={() => navigate("/dashboard")} />
        </div>
      </div>
    </div>
  );
}
